import { computed, Component,inject, Input } from '@angular/core';
import { userStore } from '../../../stores/user.store';
import { ThemeService } from '../../../services/theme.service';
import {MatIconModule} from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TitleCasePipe } from '@angular/common';
import {MatToolbarModule} from '@angular/material/toolbar';
import { MatDrawer } from '@angular/material/sidenav';
import {MatTooltipModule} from '@angular/material/tooltip';
import { Router } from '@angular/router';
import {MatDividerModule} from '@angular/material/divider';
import { configStore } from '../../../stores/config.store';
import { CommonModule } from '@angular/common';
import { SwitchUserDialogComponent } from '../../dialogs/switch-user-dialog/switch-user-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { projectStore } from '../../../stores/project.store';
import { firstValueFrom } from 'rxjs';
import * as CryptoJS from 'crypto-js';
@Component({
  selector: 'app-header',
  imports: [CommonModule,MatDividerModule,MatTooltipModule,MatIconModule, MatMenuModule,TitleCasePipe,MatToolbarModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
protected userStore = inject(userStore);
protected themeService = inject(ThemeService);
protected configStore = inject(configStore);
protected projectStore = inject(projectStore);
protected dialog = inject(MatDialog);
userName = computed(() => {
  const user = this.userStore.user();
  return user?.attributes?.first_name || 'Guest';
});
  @Input()side_drawer!:MatDrawer;
  @Input()parent:any;
  router = inject(Router);
  
  
  logout(){
    this.userStore.logout();
    this.router.navigate(['/login']);
  }

  async openSwitchUserDialog() {
    const dialogRef = this.dialog.open(SwitchUserDialogComponent, {
      width: '400px'
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        console.log('Switching to user:', result.username);
        console.log(this.projectStore.projects());
        const project = this.projectStore.projects()?.find((project: any) => project.project_name === this.configStore.currentProject());
        const env = project?.public___project_envs.find((env: any) => env.env_name === this.configStore.currentEnv());
        const service = env?.public___project_services.find((service: any) => service.service_name === this.configStore.currentService());
        console.log('Environment:', env);
        console.log('Service:', service);
        
        const hashedPassword = CryptoJS.SHA512(result.password).toString();
        await this.configStore.LoginWithUserPassword(env?.login_url_path || '', result.username, hashedPassword, env?.auth_header_name || '', env?.auth_header_value || '');
      }
    });
  }
}
